import EmberObject from '@ember/object';

export default class BaseFilterResponse extends EmberObject {
  getNumberOfStages(
    passbandAttenuation,
    stopbandAttenuation,
    passbandFrequency,
    stopbandFrequency,
    filterResponseValue,
  ) {
    var orderNum = this.getOrder(
      passbandAttenuation,
      stopbandAttenuation,
      passbandFrequency,
      stopbandFrequency,
      filterResponseValue,
    );
    var result = orderNum % 2 === 0 ? 0 : 1;
    result += (orderNum - result) / 2;
    return result;
  }
}
